import { PostCulpritDamagedVehicleCorrectiveImagesType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/postCulpritDamagedVehicleCorrectiveImages/postCulpritDamagedVehicleCorrectiveImages.type';
import { postCulpritVehicleCorrectiveImagesFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/postCulpritDamagedVehicleCorrectiveImages/postCulpritDamagedVehicleCorrectiveImagesFunction';
import { MutationOptions } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

export const postCulpritDamagedVehicleCorrectiveImagesOptions =
  (): MutationOptions<
    AxiosResponse<any, any>,
    Error,
    PostCulpritDamagedVehicleCorrectiveImagesType
  > => ({
    mutationKey: ['postCulpritDamagedVehicleCorrectiveImagesOptions'],
    mutationFn: (params: PostCulpritDamagedVehicleCorrectiveImagesType) =>
      postCulpritVehicleCorrectiveImagesFunction(params),
  });
